import React from 'react'
import { CCard, CCardBody, CCardHeader } from '@coreui/react'
import TroniaChat from '../components/TroniaChat'

// [RGM] Página TronIA — el chat del asistente en pantalla COMPLETA
// (diseño nuevo aprobado por Rafael). El tab de Mi Cuenta solo configura
// el plan y muestra el consumo; el chat vive aquí, linkeado desde el
// Navbar (Herramientas → TronIA). Consume los endpoints /api/tronia/*.
const TroniaPage: React.FC = () => {
  return (
    <div className="p-3">
      <CCard className="mx-auto" style={{ maxWidth: 760 }}>
        <CCardHeader className="fw-semibold">
          <i className="fas fa-robot me-2" />
          TRONIA — Asistente inteligente de Cybertronica
        </CCardHeader>
        <CCardBody>
          <TroniaChat enabled />
        </CCardBody>
      </CCard>
    </div>
  )
}

export default TroniaPage
